module.exports = ['$http', 'AJAX_DOMAIN_PATH', function ($http, AJAX_DOMAIN_PATH) {//add , $rootscope
    var obj = {};
    var resp_promise;
    var mapMarkers;

    obj.query = function () {
        resp_promise = $http.post(AJAX_DOMAIN_PATH + '/api/agada_story/agada_story/selectLocations', "").then(function (response) {
            if (response) {
                mapMarkers = angular.copy(response.data);
                return (mapMarkers);
            }
        });
    }

    obj.getPromise = function () {
        return resp_promise;
    }

    obj.getMapMarkers = function () { return mapMarkers; }

    obj.query();

    return obj;
}]


//////////////////
// WEBPACK FOOTER
// ./public/js/services/mapService.js
// module id = 89
// module chunks = 0